export default __webpack_public_path__ + "facebook-ads.38597ef4.png";